import type * as React from 'react';

import * as api from '@gitbook/api-client';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { Description, FieldGroup, Group, Label } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';

/**
 * Settings to configure the style for the search button
 */
export function HeaderSearchStyleSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <FieldGroup orientation="horizontal">
            <Group>
                <Label>Search bar</Label>
                <Description>
                    Pick the style of the search bar. On small screens it's displayed as an icon
                    button.
                </Description>
            </Group>
            <Picker
                value={settings.styling.search}
                items={OPTIONS}
                onValueChange={(value) => {
                    setSettings((prev) => ({
                        ...prev,
                        styling: {
                            ...prev.styling,
                            search: value,
                        },
                    }));
                }}
            />
        </FieldGroup>
    );
}

const OPTIONS: PickerItemData<api.CustomizationSearchStyle>[] = [
    {
        value: api.CustomizationSearchStyle.Prominent,
        label: 'Prominent',
        icon: <Icon.FullWidth />,
        subtitle: 'Large bar in the middle',
    },
    {
        value: api.CustomizationSearchStyle.Subtle,
        label: 'Subtle',
        icon: <Icon.DefaultWidth />,
        subtitle: 'Small bar in the corner',
    },
];
